module.exports = __webpack_public_path__ + "img/downarw.2ceae9f9.svg";